var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card-code',[_c('b-card-body',[(_vm.showTable)?_c('products-table',{attrs:{"data":_vm.items,"fields":_vm.fields,"is-busy":_vm.isBusy},on:{"refresh":_vm.update}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }